import * as Yup from 'yup'
import passwordValidator from 'utils/validators/passwordValidator'
import emailValidator from 'utils/validators/emailValidator'
import phoneValidator from 'utils/validators/phoneValidator'

export const validationSchema = Yup.object().shape({
  password: Yup.string()
    .test(
      'passwordValidator',
      'common::validation_messages.incorrect_password_format',
      passwordValidator,
    )
    .required('common::validation_messages.required'),
  email: Yup.string()
    .test(
      'emailValidator',
      'common::validation_messages.incorrect_email_format',
      emailValidator,
    )
    .required('common::validation_messages.required'),
  phone: Yup.string()
    .required('common::validation_messages.required')
    .test(
      'phoneValidator',
      'common::validation_messages.incorrect_phone_format',
      phoneValidator,
    ),
  apply_agreement: Yup.bool().required('common::validation_messages.required'),
})
